import React, { useEffect, useState } from "react";
import { getRequest, postRequest } from "../../globalhelper/helper";
import CancelIcon from "@mui/icons-material/Cancel";
import { IoMdAddCircle, IoMdRemoveCircle } from "react-icons/io";
import { CSVLink } from "react-csv";
import GetAppIcon from "@material-ui/icons/GetApp";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Grid,
  Select,
  MenuItem,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  Tooltip,
  Dialog,
  DialogContent,
  useTheme,
  Checkbox,
  Stack,
  Alert,
  Pagination,
} from "@mui/material";
import PropTypes from "prop-types";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import { useDispatch } from "react-redux";
import {

  hideLoader,
  showAlert,
  showLoader,
} from "../../redux/Common/commonActions";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Mode } from "@mui/icons-material";

const Logs = () => {
  const [companyDetails, setCompanyDetails] = useState([]);
  const [formData, setFormData] = useState({
    company: "",
    ItemType: "",
    AccountGroup: "",
    AccountClass: "",
    AccountType: "",
  });
  const [filteredData, setFilteredData] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [accountTypes, setAccountTypes] = useState([]);
  const [accountGroups, setAccountGroups] = useState([]);
  const [accountClasses, setAccountClasses] = useState([]);
  const [responseMessage, setResponseMessage] = useState("");
  const [itemTypes, setItemTypes] = useState([]);
  // States for row selection and editing
  const [selectedRows, setSelectedRows] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [currentRowsData, setCurrentRowsData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [mode, setMode] = useState("edit"); // 'edit' or 'create'
  const [submitdisable, setSubmitdisable] = useState(false);
  let dispatch = useDispatch();
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    // Fetch company names
    getRequest("api/edureka/getCompanyAssignedToUser")
      .then((response) => {
        const responseData = response.res.data?.map((item) => ({
          value: item.orgid,
          label: item.orgname,
        }));
        setCompanyDetails(responseData);
        if (responseData?.length === 1) {
          handleChanges("company", responseData[0]);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const handleChanges = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleReset = () => {
    setFormData({
      ItemType: "",
      AccountClass: "",
      AccountType: "",
      AccountGroup: "",
      company: "",
    });
    setFilteredData([]);
    setResponseData([]);
    setSelectedRows([]);
    setCurrentRowsData([]);
    setEditMode(false);
  };
  const getMasterAccountDetermination = async () => {
    dispatch(showLoader());
    const requestBody = {
      company: formData.company?.value || formData.company,
    };
    console.log(requestBody.company, "company id");

    postRequest("api/edureka/getMasterAccountDetermination", requestBody)
      .then((response) => {
        const responseData = response.res.data.data;
        console.log(response);
        if (response.res.data.length < 1) {
          setResponseMessage("No data found");
          setFilteredData([]);
        } else {
          setResponseData(responseData);
          setFilteredData(responseData);

          // Extract unique values for AccountType, AccountGroup, and AccountClass
          const uniqueAccountTypes = [
            ...new Set(responseData?.map((item) => item.AccountType)),
          ].filter(item => item !== null && item !== undefined);
          const uniqueAccountGroups = [
            ...new Set(responseData?.map((item) => item.AccountGroup)),
          ].filter(item => item !== null && item !== undefined);
          const uniqueAccountClasses = [
            ...new Set(responseData?.map((item) => item.AccountClass)),
          ].filter(item => item !== null && item !== undefined);

          const uniquItemTypes = [
            ...new Set(responseData?.map((item) => item.ItemType)),
          ].filter(item => item !== null && item !== undefined);

          const ledgername = responseData?.map((item) => item.LedgerName);

          // Set the unique values into state
          setAccountTypes(uniqueAccountTypes);
          setAccountGroups(uniqueAccountGroups);
          setAccountClasses(uniqueAccountClasses);
          setItemTypes(uniquItemTypes);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => dispatch(hideLoader()));
  };

  useEffect(() => {
    if (formData.company?.value) {
      getMasterAccountDetermination();
    }
  }, [formData.company?.value]);

  // Filter the data based on the selected dropdown values
  useEffect(() => {
    setPage(0);
    let filtered = responseData.filter((item) => {
      return (
        (formData.ItemType === "" ||
          formData.ItemType === null ||
          item.ItemType === formData.ItemType) &&
        (formData.AccountType === "" ||
          formData.AccountType === null ||
          item.AccountType === formData.AccountType) &&
        (formData.AccountGroup === "" ||
          formData.AccountGroup === null ||
          item.AccountGroup === formData.AccountGroup) &&
        (formData.AccountClass === "" ||
          formData.AccountClass === null ||
          item.AccountClass === formData.AccountClass)
      );
    });
    setFilteredData(filtered);
  }, [
    formData.ItemType,
    formData.AccountType,
    formData.AccountGroup,
    formData.AccountClass,
  ]);

  useEffect(() => {
    const uniqueAccountTypes = [
      ...new Set(
        responseData
          ?.filter(
            (item) =>
              formData.ItemType === "" ||
              formData.ItemType === null ||
              formData.ItemType == item.ItemType
          )
          .map((item) => item.AccountType)
      ),
    ].filter(item => item !== null && item !== undefined);
    const uniqueAccountGroups = [
      ...new Set(
        responseData
          ?.filter(
            (item) =>
              (formData.ItemType === "" ||
                formData.ItemType === null ||
                formData.ItemType == item.ItemType) &&
              (formData.AccountType === "" ||
                formData.AccountType === null ||
                formData.AccountType == item.AccountType)
          )
          .map((item) => item.AccountGroup)
      ),
    ].filter(item => item !== null && item !== undefined);
    const uniqueAccountClasses = [
      ...new Set(
        responseData
          ?.filter(
            (item) =>
              (formData.AccountGroup === "" ||
                formData.AccountGroup === null ||
                formData.AccountGroup == item.AccountGroup) &&
              (formData.AccountType == item.AccountType ||
                formData.AccountType === "" ||
                formData.AccountType === null)
          )
          .map((item) => item.AccountClass)
      ),
    ].filter(item => item !== null && item !== undefined);

    setAccountTypes(uniqueAccountTypes);
    setAccountGroups(uniqueAccountGroups);
    setAccountClasses(uniqueAccountClasses);
  }, [filteredData]);
  // Function to handle checkbox selection
  const handleRowSelection = (index) => {
    console.log(index);
    const isSelected = selectedRows.includes(index);
    const newSelection = isSelected
      ? selectedRows.filter((item) => item !== index)
      : [...selectedRows, index];

    setSelectedRows(newSelection);

    if (newSelection.length > 0) {
      // Update current rows data
      const newCurrentRowsData = newSelection?.map(
        (selectedIndex) => filteredData[selectedIndex]
      );
      setCurrentRowsData(newCurrentRowsData);
      setEditMode(true);
      setMode("edit");
    } else {
      setCurrentRowsData([]);
      setEditMode(false);
    }
  };

  // Function to handle TextField changes for multiple rows
  const handleInputChange = (index, field, value) => {
    const updatedRowsData = [...currentRowsData];
    updatedRowsData[index] = {
      ...updatedRowsData[index],
      [field]: value,
    };
    setCurrentRowsData(updatedRowsData);

    // If the data is modified, automatically uncheck the row
    if (selectedRows.includes(index)) {
      const updatedSelectedRows = selectedRows.filter(
        (rowIndex) => rowIndex !== index
      );
      setSelectedRows(updatedSelectedRows);
    }
  };

  const handleRemoveRow = (index) => {
    const updatedSelection = selectedRows.filter((_, i) => i !== index); // Remove selected row
    const updatedRowsData = currentRowsData.filter((_, i) => i !== index); // Remove corresponding row data

    setSelectedRows(updatedSelection); // Update the main Table selection
    setCurrentRowsData(updatedRowsData); // Update edit section data

    if (updatedRowsData.length === 0) {
      setEditMode(false); // Turn off edit mode if no rows left to edit
    }
  };

  const getCurrentDateTime = () => {
    const date = new Date();
    return `${date.toISOString().slice(0, 10)} ${date
      .toTimeString()
      .slice(0, 8)}`;
  };

  // Submit function to send updated data to the API
  const handleSubmit = () => {
    // Extract the key combination for each row
    const duplicateRows = [];
    const uniqueCombinations = new Set();
    setSubmitdisable(true);
    currentRowsData.forEach((data, index) => {
      const combination = `${data.AccountType}-${data.ItemType}-${data.AccountGroup}-${data.AccountClass}`;

      // If the combination is already found, store the row index
      if (uniqueCombinations.has(combination)) {
        duplicateRows.push({ rowIndex: index + 1, rowData: data });
      } else {
        uniqueCombinations.add(combination);
      }
    });

    // If duplicates are found, alert the user and stop the submission
    if (duplicateRows.length > 0) {
      // const duplicateMessage = duplicateRows
      // ?.map(row => Row ${row.rowIndex}: ${JSON.stringify(row.rowData)})
      // .join('\n');
      // alert(Duplicate combinations found:\n${duplicateRows});
      const duplicateMessage = duplicateRows
        ?.map((row) => `Row ${row.rowIndex}`)
        .join(", "); // Join the row numbers into a comma-separated string
      dispatch(
        showAlert(
          `Duplicate combinations found in rows: ${duplicateMessage}`,
          "error"
        )
      );
      setSubmitdisable(false);

      return; // Stop execution if duplicates are found
    }

    // Proceed with submitting the data if no duplicates are found
    const updatedData = currentRowsData?.map((data) => ({
      ...data,
    }));
    console.log(mode);

    const requestBody = {
      data: updatedData,
      orgid: formData.company?.value,
      orgname: formData.company?.label,
      mode: mode,
      moment: getCurrentDateTime(),
      // username:"sampleone"
    };

    console.log(updatedData, "updated data");

    postRequest("api/edureka/saveMasterAccountDetermination", requestBody)
      .then((response) => {
        const responseMessage = response.res.data.message;

        if (response.res.data.status === "success") {
          dispatch(showAlert(responseMessage, "success"));

          // Reset selected rows and current rows on success
          setSelectedRows([]);
          setCurrentRowsData([]);

          setEditMode(false);

          getMasterAccountDetermination();
        } else if (response.res.data.status === "fail") {
          dispatch(showAlert(responseMessage, "error"));
          setEditMode(true);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {

        setSubmitdisable(false);
      });
  };

  const handlefilterdataChange = (index, value, item) => {
    // Create a new object with the updated LedgerName
    const updatedItem = { ...item, LedgerName: value };

    // Update the filteredData array with the new object
    const updatedData = [...filteredData];
    updatedData[index] = updatedItem;

    // Set the updated data in the state
    setFilteredData(updatedData);
  };

  const handleAddRow = () => {
    const emptyRow = {};
    columnOrder.forEach((key) => {
      emptyRow[key] = ""; // Add empty values for each key
    });

    setCurrentRowsData([...currentRowsData, emptyRow]); // Add new empty row
  };

  const columnOrder = [
    "ForPrdFrom",
    "ForPrdTo",
    "AccountType",
    "ItemType",
    "LedgerName",
    "AccountClass",
    "AccountGroup",
    "MISGrouping",
    "COA",
    "AccountCode",
    "Parameter1",
    "SingleTresholdLimit",
    "CummThresholdLimit",
    "TransactionStatus",
    "SplH",
    "Priority",
    "InPrdFrom",
    "ModifiedBy",
  ];

  const handleModeToggle = () => {
    setMode((prevMode) => (prevMode === "edit" ? "create" : "edit"));
  };
  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Search</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container columns={12} spacing={2}>
            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete
                size="small"
                fullWidth
                options={companyDetails}
                value={formData.company || ""}
                getOptionLabel={(option) => {
                  if (typeof option === "string") return option;
                  return option?.label || "";
                }}
                isOptionEqualToValue={(option, value) =>
                  option?.value === value
                }
                onChange={(event, newValue) =>
                  handleChanges("company", newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Company Name"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
            {responseData.length > 0 && (
              <>
                <Grid item xs={1} sm={2} md={3}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    options={itemTypes}
                    value={formData.ItemType || ""}
                    getOptionLabel={(option) => option ? String(option) : ""}
                    onChange={(event, newValue) =>
                      handleChanges("ItemType", newValue)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Item Type"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={1} sm={2} md={3}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    options={accountTypes}
                    value={formData.AccountType || ""}
                    getOptionLabel={(option) => option ? String(option) : ""}
                    onChange={(event, newValue) =>
                      handleChanges("AccountType", newValue)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Account Type"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={1} sm={2} md={3}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    options={accountGroups}
                    value={formData.AccountGroup || ""}
                    getOptionLabel={(option) => option ? String(option) : ""}
                    onChange={(event, newValue) =>
                      handleChanges("AccountGroup", newValue)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Account Group"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={1} sm={2} md={3}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    options={accountClasses}
                    value={formData.AccountClass || ""}
                    getOptionLabel={(option) => option ? String(option) : ""}
                    onChange={(event, newValue) =>
                      handleChanges("AccountClass", newValue)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Account Class"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>
              </>
            )}

            <Grid item xs={2} sm={3} md={4}>
              {editMode && currentRowsData.length > 0 && (
                <Button
                  onClick={handleModeToggle}
                  color="secondary"
                  variant="contained"
                >
                  {mode === "edit" ? "Copy As New" : "Edit Ledger Name Only"}
                </Button>
              )}
              &nbsp;
              <Button onClick={handleReset} color="error" variant="contained">
                Reset
              </Button>
              &nbsp;
              {editMode && responseData.length > 0 && (
                <Button color="success" variant="contained">
                  <CSVLink
                    style={{ color: "white", textDecoration: "none" }}
                    data={responseData} // The data to be downloaded
                    filename={"Master_Account_Determination.csv"} // The name of the CSV file
                    target="_blank"
                  >
                    <FileDownloadRoundedIcon />
                  </CSVLink>
                </Button>
              )}
            </Grid>
          </Grid>{" "}
        </AccordionDetails>
      </Accordion>

      {/* Edit Section */}
      {editMode && currentRowsData.length > 0 && (
        <Box>
          {/* Toggle Button */}

          <Typography variant="h5">
            {mode === "edit" ? "Edit" : "Copy As New"}
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ p: 1 }} className="auto pr-3 pl-3">
                    Remove
                  </TableCell>
                  {columnOrder?.map((key, index) => (
                    <TableCell sx={{ p: 1 }} key={index}>
                      {key}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {currentRowsData?.map((rowData, rowIndex) => (
                  <TableRow key={rowIndex}>
                    <TableCell sx={{ p: 1 }}>
                      <IconButton
                        variant="text"
                        color="error"
                        size="small"
                        onClick={() => handleRemoveRow(rowIndex)}
                      >
                        <CancelIcon />
                      </IconButton>
                    </TableCell>
                    {columnOrder?.map((key, index) => (
                      <TableCell sx={{ p: 1 }} key={index}>
                        {/* Conditionally render inputs based on mode */}
                        {mode === "edit" ? (
                          // In "Edit" mode, only `ledgerName` is editable
                          key === "LedgerName" ? (
                            <Tooltip title={rowData[key]}>
                              <TextField
                                error={!rowData[key]}
                                helperText={
                                  !rowData[key]
                                    ? "This value can't be empty"
                                    : ""
                                }
                                id="outlined-error-helper-text"
                                type="text"
                                value={rowData[key]}
                                onChange={(e) =>
                                  handleInputChange(
                                    rowIndex,
                                    key,
                                    e.target.value
                                  )
                                }
                                className="text-center p-1"
                                style={{ width: "200px", minWidth: "200px" }}
                              />
                            </Tooltip>
                          ) : (
                            <span>{rowData[key]}</span> // Non-editable columns
                          )
                        ) : (
                          // In "Create New" mode, all columns are editable
                          <Tooltip title={rowData[key]}>
                            {key === "ForPrdFrom" || key === "ForPrdTo" ? (
                              <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                  label="ForPrdFrom"
                                  value={rowData[key] || moment()}
                                  views={["day", "month", "year"]}
                                  onChange={(newValue) =>
                                    handleInputChange(rowIndex, key, newValue)
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      size="small"
                                      {...params}
                                      style={{
                                        width: "200px",
                                        minWidth: "200px",
                                      }}
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            ) : (
                              <TextField
                                error={
                                  key === "MSGrouping" ||
                                    key === "InPrdFrom" ||
                                    key === "ModifiedBy"
                                    ? false
                                    : key === "Parameter1" ||
                                      key === "SingleTresholdLimit" ||
                                      key == "CummThresholdLimit" ||
                                      key === "SplH" ||
                                      key === "Priority"
                                      ? !rowData[key] || isNaN(rowData[key])
                                      : !rowData[key]
                                }
                                disabled={
                                  key === "InPrdFrom" || key === "ModifiedBy"
                                }
                                helperText={
                                  !rowData[key] &&
                                    (key === "MSGrouping" ||
                                      key === "InPrdFrom" ||
                                      key === "ModifiedBy")
                                    ? ""
                                    : (key === "Parameter1" ||
                                      key === "SingleTresholdLimit" ||
                                      key == "CummThresholdLimit" ||
                                      key === "SplH" ||
                                      key === "Priority") &&
                                      isNaN(rowData[key])
                                      ? "This value can be numeric only"
                                      : !rowData[key]
                                        ? "This value can't be empty"
                                        : ""
                                }
                                id="outlined-error-helper-text"
                                type="text"
                                value={rowData[key]}
                                onChange={(e) =>
                                  handleInputChange(
                                    rowIndex,
                                    key,
                                    e.target.value
                                  )
                                }
                                sx={{ width: "200px", minWidth: "200px", p: 1 }}
                              />
                            )}
                          </Tooltip>
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}

                {/* Add New Row Button */}

                <TableRow>
                  <TableCell sx={{ p: 1, position: "sticky", left: 0 }}>
                    <Stack direction="row">
                      {mode === "create" && (
                        <Button
                          onClick={handleAddRow}
                          className="btn text-center"
                          style={{
                            color: "green",
                            padding: "0",
                            border: "none",
                            outline: "none",
                          }}
                        >
                          <IoMdAddCircle />
                        </Button>
                      )}

                      <Button
                        onClick={handleSubmit}
                        color="primary"
                        variant="contained"
                        sx={{ margin: "auto" }}
                        disabled={
                          (mode === "create" &&
                            currentRowsData?.some(
                              (row) =>
                                !row["LedgerName"] ||
                                !row["AccountClass"] ||
                                !row["AccountGroup"] ||
                                !row["AccountType"] ||
                                !row["ItemType"] ||
                                !row["SingleTresholdLimit"] ||
                                !row["CummThresholdLimit"] ||
                                !row["SplH"] ||
                                !row["Priority"] ||
                                !row["Parameter1"] ||
                                isNaN(row["SingleTresholdLimit"]) ||
                                isNaN(row["CummThresholdLimit"]) ||
                                isNaN(row["SplH"]) ||
                                isNaN(row["Priority"]) ||
                                isNaN(row["Parameter1"]) ||
                                !row["TransactionStatus"] ||
                                !row["ForPrdTo"] ||
                                !row["AccountCode"] ||
                                !row["COA"]
                            )) ||
                          (mode === "edit" &&
                            currentRowsData?.some(
                              (row) => !row["LedgerName"]
                            )) ||
                          submitdisable
                        }
                      >
                        Submit
                      </Button>
                    </Stack>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      {/* Display filtered data in Table */}

      {responseData.length > 0 ? (
        <>
          <Box
            align="right"
            sx={{
              m: 2,
              display: "flex",
              justifyContent: "flex-end",
              flexDirection: "row",
              gap: 2,
            }}
          >
            <>
              <Pagination
                count={Math.ceil(filteredData.length / rowsPerPage)}
                page={page + 1}
                onChange={(event, newPage) => {
                  handleChangePage(event, newPage - 1);
                }}
                variant="outlined"
                shape="rounded"
                showFirstButton
                showLastButton
              />
              &nbsp;
              <CSVLink
                size="sm"
                filename={`logs_${moment().format("YYYY-MM-DD_HH-mm-ss")}.csv`}
                data={responseData}
              >
                <Button variant="contained" color="success">
                  <GetAppIcon />
                </Button>
              </CSVLink>
            </>
          </Box>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ p: 1 }}>Copy</TableCell>
                  {columnOrder?.map((key, index) => (
                    <TableCell
                      sx={
                        key === "LedgerName" ||
                          key === "ItemType" ||
                          key === "AccountType"
                          ? { p: 1, minWidth: "150px" }
                          : { p: 1 }
                      }
                      key={index}
                    >
                      {key}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {(filteredData.length > 0 &&
                  (rowsPerPage > 0
                    ? filteredData.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    : filteredData
                  )?.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ p: 1 }}>
                        <Checkbox
                          checked={selectedRows.includes(index)}
                          onClick={() => handleRowSelection(index)}
                        />
                      </TableCell>
                      {columnOrder?.map((key, idx) => (
                        <TableCell sx={{ p: 1 }} key={idx}>
                          {(key === "ForPrdFrom" &&
                            item[key] &&
                            moment(item[key]).format("YYYY-MM-DD")) ||
                            (key === "ForPrdTo" &&
                              item[key] &&
                              moment(item[key]).format("YYYY-MM-DD")) ||
                            item[key]}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))) || (
                    <TableRow>
                      <TableCell colSpan={columnOrder?.length + 1} sx={{ p: 5 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                          }}
                        >
                          <Alert severity="error" variant="outlined">
                            No matching records found. Please adjust your search
                            criteria.
                          </Alert>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : (
        <Box
          mt={3}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
          }}
        >
          <p>{responseMessage}</p>
        </Box>
      )}
    </>
  );
};

export default Logs;
